// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEvBoltSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m8.572 11.777 3.086-3.713a.34.34 0 0 1 .394-.093.34.34 0 0 1 .145.126.34.34 0 0 0-.135-.112.34.34 0 0 0-.394.093zM14.4 10.42a.34.34 0 0 1 .305.196.34.34 0 0 1-.047.343l-3.086 3.713-.007.007 3.086-3.714a.34.34 0 0 0 .048-.342.34.34 0 0 0-.305-.196H12v-.007zM12.188 8.083l.009.014zm.009.014.009.014a.34.34 0 0 1 .045.203L12 10.42"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.094 15.765c-.38.312-1.159.37-1.714.37-.17 0-.327-.008-.442-.015l-.151-.006a2.65 2.65 0 0 1-4.54 1.049c-.158-.2-.494-.691-.576-1.055a.3.3 0 0 1-.103 0 418 418 0 0 1-2.202-.026c-1.245-.016-2.55-.033-3.767-.033a2.65 2.65 0 0 1-4.166 1.432 2.52 2.52 0 0 1-.94-1.367H3.44a.3.3 0 0 1-.1 0c-.116 0-1.179-.037-1.624-.658-.446-.62-.686-5.513 2.221-8.074C5.757 5.808 8.843 6.113 10.9 6.319c2.235.223 9.123 4.028 10.495 4.992.973.679 1.135 2.02 1.159 2.564.027.666-.08 1.577-.46 1.89m-13.6-3.815a.34.34 0 0 0 .143.332.34.34 0 0 0 .178.06h2.4l-.243 2.085a.343.343 0 0 0 .333.374.34.34 0 0 0 .267-.13l3.086-3.713a.34.34 0 0 0 .048-.343.34.34 0 0 0-.306-.196H12l.261-2.091a.34.34 0 0 0-.073-.245.34.34 0 0 0-.136-.112.34.34 0 0 0-.394.093l-3.086 3.713a.34.34 0 0 0-.079.173M8.819 12.343"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEvBoltSolid;
